import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import dayjs from 'dayjs'
import SydButton from '../../../commonDesign/Button'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import { useListScheduleInvocations } from '../../../../api/scheduler'

function InvocationHistory ({ scheduleId }) {
  const [page, setPage] = useState(1)
  const { data: invocations, isLoading } = useListScheduleInvocations(scheduleId, { page, pageSize: 25 })

  if (isLoading) return <Loading />
  if (!invocations?.length) return <EmptySection title='No Invocations' description='No invocations recorded yet.' />

  return (
    <div style={{ marginTop: '0.5rem' }}>
      <TableContainer>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Fired At</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Target ARN</TableCell>
              <TableCell>Error</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invocations.map((inv) => (
              <TableRow key={inv.invocationId}>
                <TableCell>{dayjs(inv.firedAt).format('MMM D, YYYY h:mm:ss A')}</TableCell>
                <TableCell>
                  <Chip
                    label={inv.handoffStatus}
                    size='small'
                    color={inv.handoffStatus === 'success' ? 'primary' : 'secondary'}
                  />
                </TableCell>
                <TableCell style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {inv.targetArn || '—'}
                </TableCell>
                <TableCell>{inv.handoffError || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
        <SydButton size='sm' disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</SydButton>
        <SydButton size='sm' disabled={invocations.length < 25} onClick={() => setPage(p => p + 1)}>Next</SydButton>
      </div>
    </div>
  )
}

InvocationHistory.propTypes = {
  scheduleId: PropTypes.number.isRequired
}

export default InvocationHistory
